var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgModify = function SvgModify(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "modify_svg__st0",
    d: "M7.05 22.81 1.15 24A.978.978 0 0 1 0 22.85l1.19-5.9 5.86 5.86zM2.646 15.492l11.563-11.56 5.86 5.864L8.508 21.355zM17.87.27l-2.21 2.21 5.86 5.86 2.21-2.21c.38-.38.38-1 0-1.38L19.25.27c-.38-.38-1-.38-1.38 0z"
  })));
};
export default SvgModify;